import createReducer from './createReducer'
import { Action, ActionType, Language } from '../model/model'

declare const window: any

const initialState = {
  langcode: 'en',

  text: window.nchTranslations
    ? window.nchTranslations
    : {
        dashboard: 'Dashboard',
        venue: 'Venue',
        from: 'From',
        to: 'To',
        today: 'Today',
        ok: 'OK',
        definiteBookingValue: 'DEFINITE BOOKING VALUE',
        unconfirmedBookingValue: 'UNCONFIRMED BOOKING VALUE',
        eventHeld: 'EVENT HELD',
        totalBookings: 'TOTAL BOOKINGS',
        definiteBookingPercent: 'DEFINITE BOOKING PERCENT',
        revenueEarned: 'REVENUE EARNED',
        overallStatus: 'Overall Status',
        hotelPending: 'Hotel pending',
        customerPending: 'Customer pending',
        confirms: 'Confirms',
        cancelBookings: 'CANCEL BOOKINGS',
        topCancelReasons: 'Top Cancel Reasons',
        reasons: 'Reasons',
        times: 'Times',
        viewAll: 'VIEW ALL',
        averageDefiniteBookingValue: 'AVERAGE DEFINITE BOOKING VALUE',
        averageDelegateCount: 'AVERAGE DELEGATE COUNT',
        averageLeadTime: 'AVERAGE LEAD TIME',
        bookingSources: 'Booking Sources',
        source: 'Source',
        latestUpdatedOrders: 'Latest Updated Orders',
        orderRef: 'Order Ref',
        customer: 'Customer',
        date: 'Date',
        status: 'Status',
        confirmedBookingAmount: 'Confirmed Booking Amount',
        selectedDuration: 'Selected Duration',
        noDataToDisplay: 'No data to display.',
        definiteBookings: 'DEFINITE BOOKINGS',
        futureBookings: 'Future Bookings',
        bookingStatus: 'Booking Status',
        eventHeldTooltip:
          'The number of events that took place in the time span.',
        totalBookingsTooltip:
          'The total number of booking requests that were received in the time span.',
        revenueEarnedTooltip:
          'The total value of confirmed orders that were received in the time span.',
        averageDefiniteBookingValueTooltip:
          'he average value (incl. VAT) of confirmed orders that were booked in the time span.',
        averageDelegateCountTooltip:
          'The average number of participants of an event in the time span.',
        averageLeadTimeTooltip:
          'The average number of days from the Order date to the Event date - for orders received in the time span.',
        days: 'days',
        participants: 'participants',
        majorMeasurement: 'Major Measurement',
        indicators: 'Indicators',
        unit: 'Unit',
        bookings: 'bookings',
        events: 'events',
        numberOfBookings: 'No. of Bookings',
        value: 'value',

        //bookameeting,
        nch: 'Nordic Choice Hotels',
        nchLink: 'https://www.nordicchoicehotels.com/',
        hotelsAndDestinations: 'Hotels & Destinations',
        hotelsAndDestinationsLink: 'https://www.nordicchoicehotels.com/hotels/',
        conferencesAndMeetings: 'Conferences & Meetings',
        conferencesAndMeetingsLink:
          'https://www.nordicchoicehotels.com/conferences-meetings/',
        menu: 'Menu',
        close: 'Close',
        lookingFor: 'What are you looking for?',
        specialOffers: 'Special Offers',
        specialOffersLink: 'https://www.nordicchoicehotels.com/offers/',
        ncc: 'Nordic Choice Club',
        nccLink: 'https://www.nordicchoicehotels.com/nordic-choice-club/',
        inspiration: 'Inspiration',
        inspirationLink: 'https://www.nordicchoicehotels.com/blog/',
        corporateAgreement: 'Corporate agreement',
        corporateAgreementLink:
          'https://www.nordicchoicehotels.com/about-nordic-choice-hotels/corporate-agreement/corporate-agreement/',
        sportsTeams: 'Sports Teams & Associations',
        sportsTeamsLink:
          'https://www.nordicchoicehotels.com/campaigns-and-offers/gosportive--winning-prices-for-sports/',
        ourDestinations: 'Our destinations',
        ourDestinationsLink: 'https://www.nordicchoicehotels.com/destination/',
        packages: 'Packages',
        packagesLink: 'https://www.nordicchoicehotels.com/packages',
        ourHotels: 'Our hotels',
        comfortHotel: 'Comfort Hotel®',
        comfortHotelLink: 'https://www.nordicchoicehotels.com/hotels/comfort/',
        qualityHotel: 'Quality Hotel™',
        qualityHotelLink: 'https://www.nordicchoicehotels.com/hotels/quality/',
        clarionHotelCollection: 'Clarion Hotel® | Clarion Collection®',
        clarionHotel: 'Clarion Hotel®',
        clarionHotelLink: 'https://www.nordicchoicehotels.com/hotels/clarion/',
        visitOneOf: 'Visit one of our independent hotels',
        visitOneOfLink:
          'https://www.nordicchoicehotels.com/hotels/nordic-resort/',
        becomeAMember:
          'Become a member today and get our best offers and hotel prices.',
        signUpHere: 'Sign up here!',
        signUpHereLink:
          'https://www.nordicchoicehotels.com/nordic-choice-club/join/join/?returnUrl=%2f',
        language: 'Language',
        english: 'English',
        norsk: 'Norsk',
        suomi: 'Suomi',
        svenska: 'Svenska',
        dansk: 'Dansk',
        aboutUs: 'About us',
        aboutUsLink:
          'https://www.nordicchoicehotels.com/state-of-nordic-choice-hotels/',
        mapOver: 'Map over all our hotels',
        mapOverLink:
          'https://www.nordicchoicehotels.com/hotels/?resetDestination=true',
        businessApartments: 'Business apartments',
        businessApartmentsLink:
          'https://www.nordicchoicehotels.com/business-apartments/',
        prideRoomForAll: 'Pride - Room for all',
        prideRoomForAllLink: 'https://www.nordicchoicehotels.com/pride/',
        nchApp: 'Nordic Choice Hotels app',
        nchAppLink:
          'https://www.nordicchoicehotels.com/campaigns-and-offers/hotel-app/',
        sustainability: 'Sustainability',
        sustainabilityLink:
          'https://www.nordicchoicehotels.com/social-responsibility-in-nordic-choice-hotels/',
        whistleBlowing: 'Whistleblowing',
        whistleBlowingLink:
          'https://www.nordicchoicehotels.com/social-responsibility-in-nordic-choice-hotels/ethical-trade/#whisteblowing',
        workAtNch: 'Work at Nordic Choice Hotels',
        workAtNchLink: 'https://jobs.nordicchoicehotels.com/',
        becomeAffiliate: 'Become affiliate',
        becomeAffiliateLink:
          'https://www.nordicchoicehotels.com/campaigns-and-offers/affiliate-program/',
        independentHotels: 'Independent hotels',
        independentHotelsLink:
          'https://www.nordicchoicehotels.com/hotels/nordic-resort/',
        airportHotels: 'Airport hotels',
        airportHotelsLink:
          'https://www.nordicchoicehotels.com/hotels/airport-hotels/',
        spaHotels: 'Spa hotels',
        spaHotelsLink: 'https://www.nordicchoicehotels.com/hotels/spa/',
        hotelsWithPools: 'Hotels with pools',
        hotelsWithPoolsLink:
          'https://www.nordicchoicehotels.com/hotels/hotels-with-pools/',
        customerService: 'Customer Service',
        customerServiceLink: 'https://www.nordicchoicehotels.com/customer-service/',
        contactUs: 'Contact us',
        contactUsLink: 'www.nordicchoicehotels.com/customer-service/contact-us/',
        faq: 'FAQ',
        faqLink: 'https://www.nordicchoicehotels.com/customer-service#faq',
        findYourBooking: 'Find your booking',
        findYourBookingLink:
          'https://www.nordicchoicehotels.com/my-bookings',
        bestPriceGuarantee: 'Best Price Guarantee',
        bestPriceGuaranteeLink:
          'https://www.nordicchoicehotels.com/campaigns-and-offers/best-internet-rate-guarantee/',
        userTermsForSiteAndApp: 'User terms for our site and app',
        userTermsForSiteAndAppLink:
          'https://www.nordicchoicehotels.com/legal-terms-for-website/terms-of-use/legal-terms-for-website/',
        termsAndConditionsPrivacy: 'Terms & Conditions / Privacy Policy',
        termsAndConditionsPrivacyLink:
          'https://www.nordicchoicehotels.com/terms-and-conditions/terms-and-conditions/terms-and-conditions/',
        followUs: 'Follow us',
        time: 'Time',
        meetingLength: 'Mötets längd',
        people: 'Antal deltagare',
        search: 'SEARCH',
        heroTitle:
          'Boka ditt lilla, stora, korta eller långa möte här - direkt!',
        sectionTitle: 'Inspiration och mötestips',
        a1Link:
          'https://www.nordicchoicehotels.com/blog/smart-stuff/guide-book-meetingrooms-online/',
        a1Title: 'Så bokar du mötesrum online',
        a1Caption: 'Läs vår steg för steg-guide här!',
        a1Picture:
          'https://nordic-choice.s3.amazonaws.com/img/frontpage_picture_article1.jpg',
        a2Link: 'https://www.nordicchoicehotels.se/safe-stay/',
        a2Title: 'Din säkerhet är vår högsta prioritet.',
        a2Caption:
          'Här kan du läsa om våra åtgärder för att minska smittorisken och för att din vistelse eller konferens ska bli säker.',
        a2Picture: 'https://dhjmxeltzb4a8.cloudfront.net/images/StaySafe.jpg',
        a3Link:
          'https://www.nordicchoicehotels.se/kampanjer-och-erbjudanden/bytesratt/',
        a3Title: 'Boka om eller reducera kostnadsfritt!',
        a3Caption:
          'Nu får alla hipsters med startups och mac-klistermärken ännu större flexibilitet på möten och konferenser',
        a3Picture:
          'https://dhjmxeltzb4a8.cloudfront.net/images/caleb-lucas-GFflFWIcUec-unsplash.jpg',

        a1LinkCampaigns:
          'https://www.nordicchoicehotels.com/safe-stay/',
        a1TitleCampaigns: 'New booking terms and safety procedures at our hotels',
        a1CaptionCampaigns: 'What we doing to ensure safe environments and stays for our guests and employees',
        a1PictureCampaigns:
          'https://dhjmxeltzb4a8.cloudfront.net/images/StaySafe.jpg',
        a2LinkCampaigns: 'https://www.nordicchoicehotels.com/campaigns-and-offers/change-meetings/',
        a2TitleCampaigns: 'Rebook or reduce free of charge!',
        a2CaptionCampaigns:
          'You’re more than welcome to change your mind. You, your neighbour and your dog can now enjoy flexible meetings and conferences with us.',
        a2PictureCampaigns: 'https://dhjmxeltzb4a8.cloudfront.net/images/caleb-lucas-GFflFWIcUec-unsplash.jpg',
        a3LinkCampaigns:
          'https://www.nordicchoicehotels.com/blog/smart-stuff/guide-book-meetingrooms-online',
        a3TitleCampaigns: 'Book a Meeting: how to book a meeting room online',
        a3CaptionCampaigns:
          'You can now book meeting rooms in Stockholm online for certain Nordic Choice Hotels. You can see 360° pictures of the rooms, details for specific rooms and customize the rooms according to your needs. How does it work? Read our guide to Book a Meeting here!',
        a3PictureCampaigns:
          'https://nordic-choice.s3.amazonaws.com/img/frontpage_picture_article3_new.jpg',
        middlePartTitle:
          'Book meeting rooms easily online!',
        middlePartBody1:
          'You can now easily book meeting rooms online! You’ll get prices, information and confirmation right away. We have both small and large rooms for up to 50 people in 44 destinations. You yourself can decide whether you’d like to book a full day, half day or just a few hours - most things can be arranged! You can also add lunch and other refreshments by selecting this as part of your booking. It really couldn’t be easier!',
        middlePartBody2:
          ''
      },
  isLoading: false,
  error: null
}

export const language = createReducer(initialState, {
  [ActionType.FETCH_LANGUAGE_SUCCESS](
    state: Language,
    action: Action<Language>
  ) {
    return { ...state, ...action.payload, isLoading: false }
  },

  [ActionType.FETCHING_LANGUAGE](state: Language) {
    return { ...state, isLoading: true }
  },

  [ActionType.FETCH_LANGUAGE_FAIL](state: Language, action: Action<any>) {
    return { ...state, error: action.payload, isLoading: false }
  }
})
